// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2fr1h","name":"Header_name__1fiiC","birthday":"Header_birthday__1TNFh","skeleton":"Header_skeleton__19bMz"};